import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BasicTreeComponent } from './basic-tree.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BasicTreeIconModule } from './basic-tree-icon/basic-tree-icon.module';
import { BasicTreeTooltipModule } from './basic-tree-tooltip/basic-tree-tooltip.module';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';

@NgModule({
    imports: [
        CommonModule,
        MatIconModule,
        MatTreeModule,
        MatButtonModule,
        MatTooltipModule,
        BasicTreeIconModule,
        BasicTreeTooltipModule,
    ],
    declarations: [
        BasicTreeComponent,
    ],
    exports: [
        BasicTreeComponent,
    ],
})
export class BasicTreeModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            BasicTreeComponent,
        ]);
    }
}
